import { render, staticRenderFns } from "./Form2StyleOfProceeding.vue?vue&type=template&id=275e8108&scoped=true"
import script from "./Form2StyleOfProceeding.vue?vue&type=script&lang=ts"
export * from "./Form2StyleOfProceeding.vue?vue&type=script&lang=ts"
import style0 from "./Form2StyleOfProceeding.vue?vue&type=style&index=0&id=275e8108&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275e8108",
  null
  
)

export default component.exports